import { useMemo } from "react";
import useCurrentRouteConfig from "src/hooks/useCurrentRouteConfig";
import { RouteType } from "src/Routes/RouteConfig";

export const useShouldShowPrivateElements = () => {
  const routeConfig = useCurrentRouteConfig();
  return useMemo(() => routeConfig?.type === RouteType.PRIVATE, [routeConfig]);
};
